
import React from "react";
import { AlertCircle } from "lucide-react";

interface EmptyStateProps {
  hasSearched?: boolean;
}

export const EmptyState = ({ hasSearched = false }: EmptyStateProps) => {
  if (hasSearched) {
    return (
      <div className="p-8 text-center text-muted-foreground">
        <AlertCircle className="h-6 w-6 mx-auto mb-2" />
        <p>❌ Geen producten gevonden. Probeer een andere zoekterm of magazijnfilter.</p>
        <p className="text-sm mt-2">Tip: Probeer een deel van de naam of artikelnummer</p>
      </div>
    );
  }
  
  return (
    <div className="p-8 text-center text-muted-foreground">
      <p>Voer minimaal 2 tekens in om te zoeken of selecteer een magazijn</p>
    </div>
  );
};
